/**
 * "Your popups are paused" warning — shown when the shop has used its whole
 * monthly popup-impression allowance.
 *
 * Why it exists: at the cap the storefront gate (api/helpers/campaignHelpers.js
 * getCampaignsForShop → api/helpers/impressionQuota.js) serves ZERO campaigns with
 * an HTTP 200, so nothing on the storefront or in the admin tells the merchant
 * their popups stopped. This banner is the only signal.
 *
 * `limit` must be a finite number > 0 or nothing renders — a nullish limit means
 * "unlimited / unknown" and must never paint a paused warning.
 *
 * Callers must not render this while `shop` is undefined (see the EARLY_MOUNT /
 * `!shop` hold rule in .claude/rules/frontend.md); it also guards on its inputs.
 */
export function isPopupQuotaExhausted(count, limit) {
  return (
    typeof limit === "number" &&
    Number.isFinite(limit) &&
    limit > 0 &&
    typeof count === "number" &&
    Number.isFinite(count) &&
    count >= limit
  );
}

export default function PopupsPausedBanner({ count, limit, onUpgrade }) {
  if (!isPopupQuotaExhausted(count, limit)) return null;

  return (
    <s-banner tone="warning" heading="Your popups are paused">
      <s-paragraph>
        You&apos;ve used all {limit.toLocaleString()} popups shown this month, so your
        campaigns aren&apos;t showing to shoppers. They&apos;ll resume when your allowance
        resets, or upgrade now to keep them showing.
      </s-paragraph>
      {onUpgrade && (
        <s-button slot="secondary-actions" variant="secondary" onClick={onUpgrade}>
          Upgrade plan
        </s-button>
      )}
    </s-banner>
  );
}
